import classesK from '../kalkulatori.module.css'
import { useState, Fragment, useEffect } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'

const calculatorType = 'Kosarka poeni igraca'

const KosarkaPoeniIgraca = () => {
  const [disabled, setDisabled] = useState(true)
  const [showInputArea, setShowInputArea] = useState(true)
  const [playerCount, setPlayerCount] = useState(1)
  const [data, setData] = useState({
    values: {
      odds: Array(3).fill(''), // [KI1, KIX, KI2]
      teamPoints: Array(6).fill(''), // [homeScored, homeConceded, homeGames, awayScored, awayConceded, awayGames]
      players: Array(5)
        .fill()
        .map(() => ({
          host: Array(3).fill(''), // [name, points, games]
          guest: Array(3).fill(''),
        })),
    },
    results: {
      prediction: {
        min: 0,
        avg: 0,
        max: 0,
      },
      players: Array(5)
        .fill()
        .map(() => ({
          host: {
            name: '',
            min: 0,
            avg: 0,
            max: 0,
          },
          guest: {
            name: '',
            min: 0,
            avg: 0,
            max: 0,
          },
        })),
      strength: {
        home: {
          SND: 0,
          SOD: 0,
        },
        away: {
          SNG: 0,
          SOG: 0,
        },
        combined: {
          SNDG: 0,
          SODG: 0,
        },
        balance: {
          SNDSOG: 0,
          SODSNG: 0,
        },
      },
    },
  })

  const teamStrengths = [
    {
      subtitle: 'Snaga domaćina',
      keys: ['SND', 'SOD'],
      source: data?.results?.strength?.home,
      names: ['SND ( snaga napada )', 'SOD ( snaga odbrane )'],
    },
    {
      subtitle: 'Snaga gosta',
      keys: ['SNG', 'SOG'],
      source: data?.results?.strength?.away,
      names: ['SNG ( snaga napada )', 'SOG ( snaga odbrane )'],
    },
    {
      subtitle: 'Snage oba tima zajedno',
      keys: ['SNDG', 'SODG'],
      source: data?.results?.strength?.combined,
      names: [
        'SNDG ( snaga napada domaćina i gosta )',
        'SODG ( snaga odbrane domaćina i gosta )',
      ],
    },
    {
      subtitle: 'Tim proseci odbrana i napada',
      keys: ['SNDSOG', 'SODSNG'],
      source: data?.results?.strength?.balance,
      names: [
        'SND + SOG ( dom. daje / gost prima )',
        'SOD + SNG ( dom. prima / gost daje )',
      ],
    },
  ]

  // determine if button is disabled
  useEffect(() => {
    const { odds, teamPoints, players } = data.values

    const oddsIncomplete = odds.some(
      (val) => val === '' || val === null || val === undefined
    )
    const teamPointsIncomplete = teamPoints.some(
      (val) => val === '' || val === null || val === undefined
    )

    const player1 = players[0]
    const hostIncomplete = player1.host.some(
      (val) => val === '' || val === null || val === undefined
    )
    const guestIncomplete = player1.guest.some(
      (val) => val === '' || val === null || val === undefined
    )
    const player1Incomplete = hostIncomplete || guestIncomplete

    setDisabled(oddsIncomplete || teamPointsIncomplete || player1Incomplete)
  }, [data.values])

  const clearFields = () => {
    setData({
      values: {
        odds: Array(3).fill(''),
        teamPoints: Array(6).fill(''),
        players: Array(5)
          .fill()
          .map(() => ({
            host: ['', '', ''],
            guest: ['', '', ''],
          })),
      },
      results: {
        prediction: {
          min: 0,
          avg: 0,
          max: 0,
        },
        players: Array(5)
          .fill()
          .map(() => ({
            host: {
              name: '',
              min: 0,
              avg: 0,
              max: 0,
            },
            guest: {
              name: '',
              min: 0,
              avg: 0,
              max: 0,
            },
          })),
        strength: {
          home: {
            SND: 0,
            SOD: 0,
          },
          away: {
            SNG: 0,
            SOG: 0,
          },
          combined: {
            SNDG: 0,
            SODG: 0,
          },
          balance: {
            SNDSOG: 0,
            SODSNG: 0,
          },
        },
      },
    })
    setPlayerCount(1)
    setShowInputArea(true)
  }

  const handleButtonClick = () => {
    if (!showInputArea) {
      clearFields()
      setDisabled(true)
      return
    } else {
      handleCalculate()
    }

    setShowInputArea((prev) => !prev)
  }

  const handleCalculate = () => {
    const { values } = data
    const updatedResults = data.results

    // extract teamPoints from data
    const [
      homeScored,
      homeConceded,
      homeGames,
      awayScored,
      awayConceded,
      awayGames,
    ] = values.teamPoints.map(Number)

    // strength calculations
    const SND = Number((homeScored / homeGames || 0).toFixed(2))
    const SOD = Number((homeConceded / homeGames || 0).toFixed(2))
    const SOG = Number((awayScored / awayGames || 0).toFixed(2))
    const SNG = Number((awayConceded / awayGames || 0).toFixed(2))

    const SNDG = Number(((SND + SNG) / 2).toFixed(2))
    const SODG = Number(((SOD + SOG) / 2).toFixed(2))
    const SNDSOG = Number(((SND + SOG) / 2 || 0).toFixed(2))
    const SODSNG = Number(((SOD + SNG) / 2 || 0).toFixed(2))

    const attackStrength = Number((SND + SOD).toFixed(2))
    const defenseStrength = Number((SOG + SNG).toFixed(2))
    const avgTotalPoints = Number(
      ((attackStrength + defenseStrength) / 2).toFixed(2)
    )

    updatedResults.strength = {
      home: { SND, SOD },
      away: { SNG, SOG },
      combined: { SNDG, SODG },
      balance: { SNDSOG, SODSNG },
    }

    // extract odds
    const [KI1, KIX, KI2] = values.odds.map(Number)
    const impKI1 = (1 / KI1) * 100
    const impKIX = (1 / KIX) * 100
    const impKI2 = (1 / KI2) * 100

    const totalMargin = impKI1 + impKIX + impKI2 - 100
    const adjHome = impKI1 - totalMargin / 3
    const adjDraw = impKIX - totalMargin / 3
    const adjAway = impKI2 - totalMargin / 3

    const homeWinPercent = impKI1 - (adjHome * totalMargin) / 100
    const drawPercent = impKIX - (adjDraw * totalMargin) / 100
    const awayWinPercent = impKI2 - (adjAway * totalMargin) / 100

    // points calculations
    const drawImpact = drawPercent
    const slightReduction = avgTotalPoints * 0.0102
    const adjustedBase = avgTotalPoints - slightReduction

    const minTotalPoints = avgTotalPoints - (drawImpact / 100) * adjustedBase
    const maxRange = adjustedBase - minTotalPoints + adjustedBase
    const maxTotalPoints = maxRange + 1.0123

    // shared base logic for splits
    const homeWeighted = homeWinPercent + drawPercent / 2
    const awayWeighted = awayWinPercent + drawPercent / 2

    const homeImpact = (homeWeighted * adjustedBase) / 100
    const awayImpact = (awayWeighted * adjustedBase) / 100

    const maxChance = Math.max(homeImpact, awayImpact)
    const minChance = Math.min(homeImpact, awayImpact)

    const diff = Math.abs(maxChance - minChance) / 5
    const adjustment = diff / 2

    const splitPoints = (total, floor = false) => {
      let homePoints, awayPoints
      if (homeImpact >= awayImpact) {
        homePoints = total / 2 + adjustment
        awayPoints = total / 2 - adjustment
      } else {
        homePoints = total / 2 - adjustment
        awayPoints = total / 2 + adjustment
      }
      return [
        floor ? Math.floor(homePoints) : Math.round(homePoints),
        floor ? Math.floor(awayPoints) : Math.round(awayPoints),
      ]
    }

    const minSplit = splitPoints(minTotalPoints)
    const avgSplit = splitPoints(adjustedBase)
    const maxSplit = splitPoints(maxTotalPoints, true)

    // fill the results.prediction object
    updatedResults.prediction.min = `${minSplit[0]} : ${minSplit[1]}`
    updatedResults.prediction.avg = `${avgSplit[0]} : ${avgSplit[1]}`
    updatedResults.prediction.max = `${maxSplit[0]} : ${maxSplit[1]}`

    // setting the probabilities based on adjusted values
    updatedResults.prediction.probabilities = {
      home: homeWinPercent,
      draw: drawPercent,
      away: awayWinPercent,
    }

    // reset the players array before updating it** (important to clear any old data)
    updatedResults.players = []

    updatedResults.players = calculatePlayers(
      values.players,
      updatedResults.strength,
      updatedResults.prediction
    )

    setData((prev) => ({
      ...prev,
      results: updatedResults,
    }))
  }

  const calculatePlayers = (players, strength, prediction) => {
    return players.map((player) => {
      const hostPoints = parseFloat(player.host[1])
      const hostGames = parseFloat(player.host[2])
      const guestPoints = parseFloat(player.guest[1])
      const guestGames = parseFloat(player.guest[2])

      const hostName = player.host[0] || ''
      const guestName = player.guest[0] || ''

      const hostAvg = hostPoints / hostGames || 0
      const guestAvg = guestPoints / guestGames || 0

      const hostPercent = (hostAvg / strength.home.SND) * 100 || 0
      const guestPercent = (guestAvg / strength.away.SNG) * 100 || 0

      const [minH, minG] = prediction.min
        .split(' : ')
        .map((v) => Math.round(Number(v)))
      const [avgH, avgG] = prediction.avg
        .split(' : ')
        .map((v) => Math.round(Number(v)))
      const [maxH, maxG] = prediction.max
        .split(' : ')
        .map((v) => Math.round(Number(v)))

      return {
        host: {
          name: hostName,
          min: +((hostPercent * minH) / 100).toFixed(2),
          avg: +((hostPercent * avgH) / 100).toFixed(2),
          max: +((hostPercent * maxH) / 100).toFixed(2),
        },
        guest: {
          name: guestName,
          min: +((guestPercent * minG) / 100).toFixed(2),
          avg: +((guestPercent * avgG) / 100).toFixed(2),
          max: +((guestPercent * maxG) / 100).toFixed(2),
        },
      }
    })
  }

  return (
    <>
      <div className={classesK.container}>
        <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />

        <div className={classesK.contentContainer}>
          <div className={classesK.submitWrapper}>
            <span>Unesi nove obračunske podatke</span>
            <button onClick={handleButtonClick} disabled={disabled}>
              {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
            </button>
          </div>
          {showInputArea && (
            <>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod utakmice
              </div>
              <OddsCalculator
                data={data.values}
                field={'odds'}
                setData={setData}
                // calculation={handleCalculate}
                labelPrefix={['KI 1', 'KI X', 'KI 2']}
                type={Array(3).fill('number')}
                step={Array(3).fill('0.1')}
                min={Array(3).fill('1')}
                rows={3}
              />

              <div className={classesK.sectionTitle}>
                Upiši br. poena / br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                field={'teamPoints'}
                setData={setData}
                // calculation={handleCalculate}
                labelPrefix={[
                  'DOM + ( dom. dao poena )',
                  'DOM - ( dom. primio poena )',
                  'DOM BR. ( dom. odigrao utakmica )',
                  'GOST + ( gost. dao poena )',
                  'GOST - ( gost primio poena )',
                  'GOST BR. ( gost odigrao utakmica )',
                ]}
                type={Array(6).fill('number')}
                step={Array(6).fill('1')}
                min={Array(6).fill('1')}
                rows={3}
              />

              {Array.from({ length: playerCount }).flatMap((_, playerIndex) =>
                ['domaćin', 'gost'].map((role, roleIndex) => (
                  <Fragment key={`${playerIndex}-${role}`}>
                    <div className={classesK.sectionTitle}>
                      Upiši podatke za igrača {playerIndex + 1} - {role}
                    </div>
                    <OddsCalculator
                      data={data.values}
                      field={`players[${playerIndex}].${
                        role === 'domaćin' ? 'host' : 'guest'
                      }`}
                      setData={setData}
                      header={
                        playerIndex === 0
                          ? 'Obavezan unos-opcija igrač 1 (dom. ili gost)'
                          : 'Unos nije obavezan'
                      }
                      labelPrefix={[
                        'IGRAČ ( opciono ime, prezime, nadimak )',
                        'POENI ( ukupan broj poena )',
                        'BR. UTAK. ( broj ut. na koji se odnosi br. poena )',
                      ]}
                      type={['text', 'number', 'number']}
                      step={Array(3).fill('1')}
                      min={Array(3).fill('1')}
                      rows={2}
                      lastWide={true}
                    />
                  </Fragment>
                ))
              )}

              {playerCount < 5 && (
                <div className={classesK.addMore}>
                  <button
                    onClick={() => setPlayerCount((prev) => prev + 1)}
                    className={classesK.addButton}
                  >
                    <img src={add} height={18} width={18} alt='add' />
                    Dodaj još igrača
                  </button>
                </div>
              )}
            </>
          )}

          {!showInputArea && (
            <div className={classesK.sectionResults}>
              <ResultsSection
                title={`Tačan rezultat`}
                subtitle={`Opciono mogući tačan rezultat`}
                results={[
                  data?.results?.prediction?.min,
                  data?.results?.prediction?.avg,
                  data?.results?.prediction?.max,
                ]}
                names={[
                  'Predikcija minimalnog tačnog rezultata',
                  'Predikcija srednjeg tačnog rezultata',
                  'Predikcija maksimalnog tačnog rezultata',
                ]}
                rows={2}
              />

              {data?.results?.players
                ?.filter(
                  (player) =>
                    (player?.host?.name || player?.guest?.name) && // if host or guest have a name
                    ((player?.host?.min !== 0 &&
                      player?.host?.avg !== 0 &&
                      player?.host?.max !== 0) ||
                      (player?.guest?.min !== 0 &&
                        player?.guest?.avg !== 0 &&
                        player?.guest?.max !== 0))
                )
                .flatMap((player, playerIndex) =>
                  ['host', 'guest'].map((role, roleIndex) => {
                    const roleData = player[role]
                    const subtitle = `Poeni igrača ${playerIndex + 1} ( ${
                      role === 'host' ? 'domaćin' : 'gost'
                    } )`
                    const isFirst = playerIndex === 0 && roleIndex === 0

                    // check if this role has data
                    if (!roleData?.name) return null

                    return (
                      <ResultsSection
                        key={`${playerIndex}-${role}`}
                        title={isFirst ? 'Poeni igrača' : undefined}
                        subtitle={subtitle}
                        results={[
                          roleData?.name || '-',
                          roleData?.min ?? '-',
                          roleData?.avg ?? '-',
                          roleData?.max ?? '-',
                        ]}
                        names={[
                          'Igrač',
                          'Minimalni očekivani broj poena',
                          'Srednji očekivani broj poena',
                          'Maksimalni očekivani broj poena',
                        ]}
                        rows={2}
                      />
                    )
                  })
                )}

              {teamStrengths.map((config, index) => (
                <ResultsSection
                  key={index}
                  title={index === 0 ? 'Snage timova' : undefined}
                  subtitle={config.subtitle}
                  results={config.keys.map(
                    (key) => config.source?.[key] ?? '-'
                  )}
                  names={config.names}
                  rows={2}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default KosarkaPoeniIgraca
